import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { useRequestHandler } from '@/hooks/useRequestHandler'

import ConfigureStripeStep from '@/pages/getting-started/components/ConfigureStripeStep'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { configureStripePayment, selectConfigureStripePaymentRequestTracker } from '@/redux/reducers/staff.reducer'

export function ConfigureStripeStepContainer() {
  const location = useLocation()
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  const authUser = useAppSelector(selectAuthUser)

  const { dispatch, requestTracker } = useRequestHandler({
    onSuccess: () => { },
    onError: () => {
      enqueueSnackbar(t('notification.authUser.update.error'), { variant: 'error' })
    },
    requestTrackerSelector: selectConfigureStripePaymentRequestTracker
  })

  const handleConnectOnboarding = () => {
    if (!authUser) return
    dispatch(configureStripePayment({
      staffId: authUser._id,
      refreshUrl: `${window.location.origin}${location.pathname}?step=configure-stripe`,
      returnUrl: `${window.location.origin}${location.pathname}?step=configure-cps-card`
    }))
  }

  return (
    <ConfigureStripeStep
      confirmText={t('common:button.continue.label')}
      isSubmitting={requestTracker.loading}
      onConnectOnboarding={handleConnectOnboarding}
    />
  )
}

export default ConfigureStripeStepContainer